import { useState } from "react";
import * as yup from "yup";
import { Row, Col } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { WebLayout } from "../components/web-layout";
import { SubmitButton } from "../../components/buttons/submit-button";
import { API } from "../../utils/AxiosInstance";
import { ErrorText } from "../../components/error-text";
import { useBranding } from "../../contexts/branding";
import { Spacer } from "../components/spacer";
import PasswordSendDialog from "./password-send-dialog";

interface State {
    email: string;
    base?: string;
}

export function ForgotPassword() {
    const { t } = useTranslation();
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const { label } = useBranding();
    const schema = yup.object().shape({
        email: yup.string().email().required(t("is required")),
    });

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        setError,
    } = useForm<State>({
        resolver: yupResolver(schema),
    });

    async function onSubmit(params: State) {
        try {
            await API.post(`/password_resets/`, { ...params });
            setShowDialog(true);
        } catch {
            setError("email", {
                type: "server",
                message: t("no_match_email"),
            });
        }
    }

    return (
        <WebLayout>
            <PasswordSendDialog show={showDialog} />
            <Row>
                <Col
                    xs={12}
                    md={{ offset: 2, span: 8 }}
                    lg={{ offset: 2, span: 8 }}
                >
                    <div className="login-header-text">
                        {t("Forgot password?")}
                    </div>
                    <Spacer height={5} />
                    <div className="text-md">
                        {t("login.forgot_password_text_1")}
                    </div>
                    <Spacer height={24} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="login-label">{t("email_id")}</div>
                        <input
                            type="text"
                            placeholder={t("email_placeholder")}
                            className="form-control field-height"
                            {...register("email")}
                        />
                        {errors.email && (
                            <ErrorText text={errors.email.message} />
                        )}
                        {errors.base && (
                            <ErrorText text={errors.base.message} />
                        )}
                        <Spacer height={40} />
                        <SubmitButton
                            isSubmitting={isSubmitting}
                            label={t("Submit")}
                            className={`form-control field-height ${
                                label !== "HabitNu" ? "ada-btn-success" : ""
                            }`}
                        />
                    </form>
                </Col>
            </Row>
        </WebLayout>
    );
}
